import React from "react";
import { HC } from "../hr/theme";
import { naira, compactNaira } from "../../lib/format";

export const money = (v) => naira(v || 0);
export const cmoney = (v) => compactNaira(v || 0);
export const num = (v) => Number(v || 0).toLocaleString();
export const dt = (v) => (v ? String(v).slice(0, 16).replace("T", " ") : "—");

export const Kpi = ({ label, value, sub, testid, onClick, tone = "burgundy" }) => (
  <div data-testid={testid} onClick={onClick}
    className={`rounded-2xl bg-white border p-4 ${onClick ? "cursor-pointer hover:shadow-md hover:border-[#C49A4A]" : ""}`}
    style={{ borderColor: HC.border }}>
    <div className="text-[11.5px] font-medium" style={{ color: HC.muted }}>{label}</div>
    <div className="font-brand font-bold text-[24px] leading-tight mt-1" style={{ color: HC[tone] || HC.text }}>{value}</div>
    {sub && <div className="text-[11px] mt-0.5" style={{ color: HC.soft }}>{sub}</div>}
  </div>
);

export const Bars = ({ title, rows = [], format = num, testid, empty = "No data yet" }) => {
  const max = Math.max(...rows.map((r) => r.value || 0), 1);
  return (
    <div className="rounded-2xl bg-white border p-5" style={{ borderColor: HC.border }} data-testid={testid}>
      <h3 className="font-brand font-bold text-base mb-3" style={{ color: HC.text }}>{title}</h3>
      {rows.length === 0 ? (
        <div className="text-[12.5px] py-6 text-center" style={{ color: HC.soft }}>{empty}</div>
      ) : rows.slice(0, 8).map((r, i) => (
        <div key={i} className="flex items-center gap-3 mb-2.5">
          <div className="w-28 text-[12px] truncate" style={{ color: HC.text }}>{r.name}</div>
          <div className="flex-1 h-2 rounded-full" style={{ background: "#F1E7D3" }}>
            <div className="h-full rounded-full" style={{ width: `${Math.max(4, ((r.value || 0) / max) * 100)}%`, background: HC.burgundy }} />
          </div>
          <div className="w-20 text-right text-[12px] font-brand font-bold tabular-nums" style={{ color: HC.text }}>{format(r.value)}</div>
        </div>
      ))}
    </div>
  );
};

export const DataTable = ({ columns, rows = [], onRowClick, testid, empty = "No records", render = {} }) => (
  <div className="rounded-2xl bg-white border overflow-hidden" style={{ borderColor: HC.border }} data-testid={testid}>
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-[10px] uppercase tracking-widest" style={{ color: HC.soft, background: HC.panelSoft }}>
            {columns.map(([k, label]) => <th key={k} className="px-4 py-3 whitespace-nowrap">{label}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && (
            <tr><td colSpan={columns.length} className="px-4 py-10 text-center text-[12.5px]" style={{ color: HC.soft }}>{empty}</td></tr>
          )}
          {rows.map((r, i) => (
            <tr key={`${r.id || "row"}-${i}`} onClick={() => onRowClick?.(r)}
              data-testid={`${testid}-row-${i}`}
              className={`border-t ${onRowClick ? "cursor-pointer hover:bg-[#FBF8F2]" : ""}`} style={{ borderColor: HC.borderSoft }}>
              {columns.map(([k]) => (
                <td key={k} className="px-4 py-3 text-[12.5px] whitespace-nowrap" style={{ color: HC.text }}>
                  {render[k] ? render[k](r) : (r[k] === null || r[k] === undefined || r[k] === "" ? "—" : String(r[k]))}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export const Pager = ({ page, pageSize, total, onPage, testid = "pager" }) => {
  const pages = Math.max(1, Math.ceil((total || 0) / pageSize));
  return (
    <div className="flex items-center justify-between mt-3 text-[12px]" style={{ color: HC.muted }} data-testid={testid}>
      <span>{total} records · page {page} of {pages}</span>
      <span className="flex gap-2">
        <button disabled={page <= 1} onClick={() => onPage(page - 1)} data-testid={`${testid}-prev`}
          className="h-8 px-3 rounded-md border disabled:opacity-40" style={{ borderColor: HC.border }}>Previous</button>
        <button disabled={page >= pages} onClick={() => onPage(page + 1)} data-testid={`${testid}-next`}
          className="h-8 px-3 rounded-md border disabled:opacity-40" style={{ borderColor: HC.border }}>Next</button>
      </span>
    </div>
  );
};
